/* @flow */

import * as React from 'react';
import { observable } from 'mobx';
import { inject, observer } from 'mobx-react';
import { translate } from 'react-i18next';
import type { TranslatorProps } from 'react-i18next';

import Button from '@material-ui/core/Button';

import type TypeActionDrawerStore from 'stores/ActionDrawerStore.js';

import Loading from 'components/Loading/Loading';

import ActionDrawerHeader from '../../../components/ActionDrawerHeader/ActionDrawerHeader';
import AddNewCostCenterForm from './AddNewCostCenterForm';
import AddNewCostCenterSuccess from './AddNewCostCenterSuccess';
import Form from '../../../../../forms/_.extend';

import styles from '../../../ActionDrawer.module.scss';

type TypeProps = {|
  formData: Object,
  actionDrawerStore: TypeActionDrawerStore,
|} & TranslatorProps;

@translate()
@inject('actionDrawerStore')
@observer
export default class AddNewCostCenter extends React.Component<*> {
  @observable vModelData = this.props.model;

  @observable vChildModelData = this.props.childmodel;

  /**
   * Our Default field list, of which is overridable by props
   * We use this to be
   * @type {{site: string, system: string, company: string, account: string, building: string, room: string}}
   */
  defaultFieldList: Object = {
    account: 'chooseAccount.tradingAccount',
    costCentre: 'assignCostCentre.costCentreAssign',
  };

  createForm = () => {
    const { t }: TranslatorProps = this.props;
    const { actionDrawerStore }: TypeProps = this.props;
    const { parentForm, fieldList = null }: Object = this.props;

    if (fieldList) {
      this.defaultFieldList = fieldList;
    }

    const fields: Array<Object> = [
      {
        name: 'addNewCostCenter',
        label: t('general:actions.new_cost_center'),
        title: 'New Cost Center',
        fields: [
          {
            name: 'tradingAccount',
            label: t('general:trading_account'),
            rules: 'required|string',
            disabled: Boolean(parentForm.$(`${this.defaultFieldList.account}`).extra.selectID),
            value: parentForm.$(`${this.defaultFieldList.account}`).extra.selectID,
          },
          {
            name: 'costCenterName',
            label: t('general:cost_centers.labels.name'),
            rules: 'required|string',
            value: '',
          },
          {
            name: 'costCenterCode',
            label: t('general:cost_centers.labels.code'),
            rules: 'required|string',
            value: '',
          },
          {
            name: 'costCenterDesc',
            label: t('general:cost_centers.labels.description'),
            rules: 'string',
            value: '',
          },
        ],
      },
    ];

    const hooks: Object = {
      onSuccess(data: Object) {
        const {
          tradingAccount,
          costCenterName,
          costCenterCode,
          costCenterDesc,
        }: Object = data.values().addNewCostCenter;

        const jsonObj: Object = {
          account_id: tradingAccount, //parentForm.$('chooseAccount.tradingAccount').value,
          name: costCenterName,
          code: costCenterCode,
          description: costCenterDesc,
          is_enabled: true,
        };

        !costCenterDesc && delete jsonObj.description;

        actionDrawerStore.userAddCostCenter(jsonObj);
      },
    };

    return new Form(
      { fields },
      {
        hooks,
        options: {
          validateOnInit: true,
          validateOnChange: true,
        },
        name: t('general:actions.new_cost_center'),
      }
    );
  };

  render(): React.Element<*> {
    const { t }: TranslatorProps = this.props;
    const { actionDrawerStore }: TypeProps = this.props;
    const { parentForm }: Object = this.props;

    if (actionDrawerStore.loading) {
      return <Loading />;
    }

    if (actionDrawerStore.error) {
      return (
        <div className={styles['action-drawer-content']}>
          <ActionDrawerHeader title={t('general:actions.create_new_cost_center')} />
          <div className={styles['action-drawer-content']}>
            {actionDrawerStore.errorResponse.message}
          </div>
          <div className={styles['action-drawer-actions']}>
            <Button
              color="primary"
              variant="contained"
              onClick={() => actionDrawerStore.closeActionDrawer()}
            >
              {t('general:actions.close')}
            </Button>
          </div>
        </div>
      );
    }

    if (actionDrawerStore.success) {
      return (
        <AddNewCostCenterSuccess
          parentForm={parentForm}
          model={this.props.model}
          childmodel={this.props.childmodel}
          localState={this.props.localState}
          fields={this.defaultFieldList}
        />
      );
    }

    return (
      <div className={styles['action-drawer-form']}>
        <ActionDrawerHeader title={t('general:actions.create_new_cost_center')} />
        <AddNewCostCenterForm form={this.createForm()} accountsModel={this.props.accountsModel} />
      </div>
    );
  }
}
